import {
  images,
  scrolling,
} from 'assets/utilities';

import './error.scss';

const STATE_CLASSNAME = 'state--error';

const destroy = function destroyError() {
  document.body.classList.remove(STATE_CLASSNAME);
};

const init = function initError() {
  document.body.classList.add(STATE_CLASSNAME);
  window.scrollTo(0, 0);
  scrolling.rebuildCache();
  images.init();
};

export default {
  destroy,
  init,
};
